import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ArticlePage from "@/pages/article/page";
import AboutPage from "@/pages/about/page";
import FaqPage from "@/pages/faq/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:slug", element: <CategoryPage /> },
      { path: "/article/:id", element: <ArticlePage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/faq", element: <FaqPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;